export default __webpack_public_path__ + "static/media/single.46536cca.svg";